import {
  fetchProjects,
  createNew,
  removeProject,
  updateProject
} from "@/api/project";
import { TOKEN_KEY } from "@/api/auth";

const headers = [
  {
    text: "Project",
    align: "left",
    sortable: true,
    value: "projectName"
  },
  {
    text: "Type",
    align: "left",
    sortable: true,
    value: "projectType"
  },
  {
    text: "Architect",
    align: "left",
    sortable: true,
    value: "architectName"
  },
  {
    text: "General Contractor",
    align: "left",
    sortable: true,
    value: "generalContractor"
  },
  {
    text: "Dealers",
    align: "left",
    sortable: true,
    value: "dealers"
  },
  {
    text: "",
    value: "actions",
    sortable: false,
    align: "left"
  }
];

const state = {
  headers,
  data: [],
  loading: false,
  selectedProject: null,
  createProjectLoading: false,
  deleteProjectLoading: false
};

const getters = {
  projects: state => state.data,
  loadingData: state => state.loading,
  createProjectLoading: state => state.createProjectLoading,
  deleteProjectLoading: state => state.deleteProjectLoading,
  projectHeaders: state => state.headers,
  selectedProject: state => state.selectedProject
};

const mutations = {
  setSelectedProject: (state, payload) => {
    state.selectedProject = payload;
  },
  deleteSelectedProject: state => {
    state.data = state.data.filter(
      project => project._id !== state.selectedProject._id
    );
  },
  setDataLoading: (state, payload) => {
    state.loading = payload;
  },
  setCreateProjectLoading: (state, payload) => {
    state.createProjectLoading = payload;
  },
  setDeleteProjectLoading: (state, payload) => {
    state.deleteProjectLoading = payload;
  },
  setProjects: (state, payload) => {
    state.data = payload;
  },
  addNew: (state, payload) => {
    state.data = [payload, ...state.data];
  },
  updateProject: (state, payload) => {
    state.data = [
      ...state.data.filter(project => project._id !== payload._id),
      payload
    ];
  }
};

const actions = {
  setSelectedProject: ({ commit }, payload) => {
    commit("setSelectedProject", payload);
  },
  deleteProject: async ({ commit, dispatch }, payload) => {
    commit("setDeleteProjectLoading", true);
    const token = localStorage.getItem(TOKEN_KEY);
    const { data } = await removeProject(token, payload._id);
    if (data.status !== 200) {
      console.log(data.message);
    } else {
      commit("deleteSelectedProject");
    }
    commit("setDeleteProjectLoading", false);
    dispatch("setSelectedProject", null);
    dispatch("toggleDeleteConfirmationModal");
  },
  getProjects: async ({ commit }) => {
    commit("setDataLoading", true);
    const token = localStorage.getItem(TOKEN_KEY);
    const { data } = await fetchProjects(token);
    if (data.status !== 200) {
      console.log(data.message);
    } else {
      commit("setProjects", data.projects);
    }
  },
  setDataLoading: ({ commit }, payload) => {
    commit("setDataLoading", payload);
  },
  createProject: async ({ commit, dispatch }, payload) => {
    commit("setCreateProjectLoading", true);
    const token = localStorage.getItem(TOKEN_KEY);
    const { data } = await createNew(token, payload);
    if (data.status !== 200) {
      console.log(data.message);
    } else {
      commit("addNew", data.project);
    }
    commit("setCreateProjectLoading", false);
    dispatch("toggleCreateProjectModal");
  },
  editProject: async ({ commit, dispatch }, payload) => {
    commit("setCreateProjectLoading", true);
    const token = localStorage.getItem(TOKEN_KEY);
    const { data } = await updateProject(token, payload);
    if (data.status !== 200) {
      console.log(data.message);
    } else {
      console.log(data);
      commit("updateProject", data.project);
    }
    commit("setCreateProjectLoading", false);
    commit("setSelectedProject", null);
    dispatch("toggleEditProjectModal");
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
